<template>
  <div v-if="isRecruiter" :err="err">
    <b-alert variant="info" show>
      Important! After attaching a role to this project it will no longer be listed among internal and/or referral jobs.
    </b-alert>
    <internal-jobs-list
      layout="select-modal"
      :loading="$apollo.loading || !jobs"
      :jobs="jobs"
      @importJob="importJob($event)"
    />
  </div>
</template>

<script>
import gql from 'graphql-tag';
import JobDetailsFragment from '@/graphql/fragments/JobDetails.gql';
import ms from 'ms';
import InternalJobsList from '@/components/projects/InternalJobsListContainer';
import InternalJobsIndex from '@/graphql/queries/InternalJobsIndex.gql';
import ProjectShowQuery from '@/graphql/queries/ProjectShow.gql';
import { mapRoot } from '@src/mixins/root';

const ImportJobMutation = gql`
  ${JobDetailsFragment}

  mutation ImportJob($jobID: ID!, $projectID: ID!) {
    updateJob(update: { project: { id: $projectID }, isInternal: true }, where: { id: $jobID }) {
      ...JobDetails
      skills
      project {
        id
      }
    }
  }
`;

export default {
  components: {
    InternalJobsList,
  },
  props: {
    projectID: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    err: null,
  }),
  apollo: {
    jobs: {
      query: InternalJobsIndex,
      variables() {
        return {
          statusIn: [ 'ACTIVE', 'INACTIVE', 'DELETED' ],
        };
      },
      update(data) {
        const { company: { jobs } = {} } = data;
        console.log('MATCHED JOB CONNECTIONS: ', { jobs });
        return jobs;
      },
      error(err) {
        this.$log.error(err);
      },
      errorPolicy: 'all',
      fetchPolicy: 'cache-and-network',
      deep: true,
      throttle: ms('1s'),
    },
  },
  computed: {
    ...mapRoot([ 'company', 'isLoggedIn', 'isRecruiter' ]),
  },
  methods: {
    async importJob({ jobID }) {
      const { projectID } = this;
      try {
        await this.$apollo.mutate({
          mutation: ImportJobMutation,
          variables: { jobID, projectID },
          update(store, { data: { updateJob: job } }) {
            const data = store.readQuery({
              query: ProjectShowQuery,
              variables: {
                projectID,
                statusIn: [ 'ACTIVE', 'INACTIVE', 'DELETED' ],
              },
            });
            if (data && data.company && data.company.project && Array.isArray(data.company.project.jobs)) {
              data.company.project.jobs.push(job);
              store.writeQuery({
                query: ProjectShowQuery,
                variables: {
                  projectID,
                  statusIn: [ 'ACTIVE', 'INACTIVE', 'DELETED' ],
                },
                data,
              });
            }
          },
        });
      } catch (err) {
        this.$log.error(err);
        this.err = `${err}`;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/projects/ImportRolesContainer.vue